<script>
	import Post from "./post.svelte";
	import { store } from "../store.js";
	import Social from "./Social.svelte";
	import mapboxgl from "mapbox-gl";

	import { onMount, beforeUpdate, afterUpdate } from "svelte";

	let map;
	let apiError = false;
	mapboxgl.accessToken = cg_vars.click_amap_mapboxapi;

	onMount(async () => {
		if (!mapboxgl.accessToken) {
			apiError = true;
			return;
		}
		buildMap();
	});

	// beforeUpdate(async () => {
	// });

	afterUpdate(async () => {
		const features = $store.posts[$$props.id].cg_posts.map(post => {
			return {
				type: "Feature",
				geometry: {
					type: "Point",
					coordinates: [post.lng, post.lat]
				},
				properties: post
			};
		});
		drawLayer(features, "annonces");
	});

	const buildMap = () => {
		const features = $store.posts[$$props.id].cg_posts.map(post => {
			return {
				type: "Feature",
				geometry: {
					type: "Point",
					coordinates: [post.lng, post.lat]
				},
				properties: post
			};
		});
		map = new mapboxgl.Map({
			container: "map",
			style: "mapbox://styles/labubulle/ckv0jeyg30qj414vot4szbxyg",
			center: [2.109667, 46.732193],
			zoom: 5
		});

		map.on("load", function () {
			drawLayer(features, "annonces");
		});
	};

	function drawLayer(data, label) {
		let color = label == "amap" ? "#DF542F" : "#3A7C3C";

		map.addSource(label, {
			type: "geojson",
			data: {
				type: "FeatureCollection",
				features: data
			},
			cluster: true,
			clusterMaxZoom: 9, // Max zoom to cluster points on
			clusterRadius: 80 // Radius of each cluster when clustering points (defaults to 50)
		});

		map.addLayer({
			id: label + "_clusters",
			type: "circle",
			source: label,
			filter: ["has", "point_count"],
			paint: {
				"circle-color": "#ffffff",
				"circle-stroke-width": 2,
				"circle-stroke-color": color,
				"circle-radius": [
					"step",
					["get", "point_count"],
					10,
					10,
					20,
					30,
					20,
					100,
					30
				]
			}
		});

		// inspect a cluster on click

		map.on("click", label + "_clusters", e => {
			const features = map.queryRenderedFeatures(e.point, {
				layers: [label + "_clusters"]
			});
			const clusterId = features[0].properties.cluster_id;
			map.getSource(label).getClusterExpansionZoom(clusterId, (err, zoom) => {
				if (err) return;
				map.easeTo({
					center: features[0].geometry.coordinates,
					zoom: zoom + 1
				});
			});
		});

		map.addLayer({
			id: label + "_cluster_count",
			type: "symbol",
			source: label,
			filter: ["has", "point_count"],
			layout: {
				"text-field": "{point_count_abbreviated}",
				"text-font": ["DIN Offc Pro Bold", "Arial Unicode MS Bold"],
				"text-size": 14
			},
			paint: {
				"text-color": color
			}
		});

		map.addLayer({
			id: label + "_unclustered_point",
			type: "circle",
			source: label,
			filter: ["!", ["has", "point_count"]],
			paint: {
				"circle-color": color,
				"circle-radius": 7,
				"circle-stroke-width": 2,
				"circle-stroke-color": "#fff"
			}
		});

		map.on("click", label + "_unclustered_point", e => {
			const coordinates = e.features[0].geometry.coordinates.slice();
			const props = e.features[0].properties;

			while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
				coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
			}

			map.on("mouseenter", label + "_unclustered_point", () => {
				map.getCanvas().style.cursor = "pointer";
			});
			map.on("mouseleave", label + "_unclustered_point", () => {
				map.getCanvas().style.cursor = "";
			});

			map.easeTo({
				center: [coordinates[0], coordinates[1] - 0.02],
				zoom: 12
			});
			setTimeout(() => {
				popup = new mapboxgl.Popup()
					.setLngLat(coordinates)
					.setHTML(setPopupHtml(props))
					.addTo(map);
			}, 500);
		});

		loading = false;
	}

	function setPopupHtml(post) {
		const { post_title, post_permalink, type_production, post_excerpt } = post;
		const type_production_data = JSON.parse(type_production);

		let html = `<div class="post_grid_map__popup">
				<h3 class="post_grid_map__title"><a href="${post_permalink}" >${post_title}</a></h3>

				${
					type_production_data &&
					type_production_data.length > 0 &&
					`<p class="post_grid_map__type">Type de production : <b>${type_production_data.map(
						type => type.name
					)}</b></p>`
				}
					<p>${post_excerpt}</p>
				</div>`;

		return html;
	}
</script>

<div
	class="post_grid_map {$store.options[$$props.id].loading == 'true'
		? 'loading'
		: 'loaded'}"
>
	{#if apiError}
		<p class="cs_nopublications cs_message">
			Clef d'API Mapbox non renseignée. Veuillez contacter l'administrateur du
			site.
		</p>
	{/if}

	{#if $store.options[$$props.id].loading == true}
		<p class="cs_nopublications cs_message">Chargement en cours...</p>
	{/if}
	{#if $store.posts[$$props.id].cg_posts && $store.posts[$$props.id].post_count > 0}
		<div class="map-wrapper">
			<div id="map"></div>
		</div>
	{:else if $store.posts[$$props.id].post_count == 0}
		<p class="cs_nopublications cs_message">
			Aucune publication ne correspond à vos filtres
		</p>
	{/if}
</div>

<style>
	.map-wrapper {
		position: relative;
		height: 600px;
		width: 100%;
		overflow: hidden;
	}
	#map {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
	}

	.mapboxgl-marker {
		position: absolute;
		top: 0;
		left: 0;
		will-change: transform;
		opacity: 1;
		transition: opacity 0.2s;
	}
</style>
